import React from 'react';
import format from 'date-fns/format';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import BoxWithTwoSections from 'components/BoxWithTwoSections';
import { DATE_WITH_HOUR } from 'utils/dateFormat';
import StatusBadge from 'components/StatusBadge';

import { disputeDetails as TEXT } from 'locales/en/dispute';

const DisputeDetails = ({ dispute }) => {
  const {
    id,
    created_at,
    amountToDisplay,
    feeToDisplay,
    transaction_id,
    reason,
    reason_code,
    status,
    defense_submitted,
    days_to_defend,
    external_id,
  } = dispute;

  return (
    <>
      <h2 className="text-base font-bold text-javelin-gray-dark lg:text-xl">
        {TEXT.detailsHeader}
      </h2>
      <BoxWithTwoSections
        textObject={TEXT}
        data={{
          left: {
            id,
            created_at: format(new Date(created_at), DATE_WITH_HOUR),
            amount: amountToDisplay,
            fee: feeToDisplay,
            transactionId: (
              <Link
                to={`/transactions/${transaction_id}`}
                className="underline"
              >
                {transaction_id}
              </Link>
            ),
          },
          right: {
            status: <StatusBadge className="ml-0" status={status} />,
            reason: reason,
            reason_code: reason_code,
            defenceSubmitted: defense_submitted ? 'Yes' : 'No',
            daysToDefend: days_to_defend,
            reference: external_id,
          },
        }}
      />
    </>
  );
};

DisputeDetails.propTypes = {
  dispute: PropTypes.shape({}),
};
DisputeDetails.defaultProps = {
  dispute: {},
};

export default DisputeDetails;
